/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, css, Fade, Grid, Typography } from '@mui/material';
import ghostIcon from 'assets/ghostIcon.svg';
import { TXT_NO_RESULTS } from 'translations';

const MenuNoResults: FC = () => {
  const { t } = useTranslation();

  return (
    <Fade in>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        justifyContent="center"
        alignItems="center"
        css={css`
          height: calc(100vh - 112px);
        `}
      >
        <Grid item>
          <Box textAlign="center">
            <img src={ghostIcon} width={80} height={80} alt="ghost" />
          </Box>

          <Typography
            css={css`
              width: 225px;
              text-align: center;
            `}
          >
            {t(TXT_NO_RESULTS)}
          </Typography>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default MenuNoResults;
